import APIClient from './APIClient';

const {
  REACT_APP_ONBOARDING_API_HOST: ONBOARDING_API_HOST,
  REACT_APP_PROVISIONAL_OFFER_ENDPOINT: PROVISIONAL_OFFER_ENDPOINT,
} = process.env;

export const urlFor = applicationId =>
  `${ONBOARDING_API_HOST}${PROVISIONAL_OFFER_ENDPOINT}`.replace('{applicationId}', applicationId);

export default class ProvisionalOfferAPI {
  static getProvisionalOfferFor = (applicationId, token) => {
    return APIClient.get(urlFor(applicationId), token).then(response => response.data);
  };

  static updateProvisionalOfferFor = (params, token) => {
    const { applicationId: appId, ...otherParams } = params;

    return APIClient.patch(
      urlFor(appId),
      {
        ...otherParams,
      },
      token,
    ).then(response => response.data);
  };
}
